import React, { Component } from 'react';
import Vas from '../Vas';

class ChangePasswordSuccess extends Component
{
    render()
    {
        return ( <div 
          className="LoginContainer">
          <div 
            className={"form"} 
            style={{ width:'400px' }}>
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Labels["ChangePasswordSuccess"]}</h2></th>
                </tr>
              </thead>
              <tbody>
              </tbody>
            </table> 
          </div>
        </div>);
    }
}
export default ChangePasswordSuccess;
